import { autoinject } from 'aurelia-framework';
import { Models } from 'models/core';
import { NetService } from 'services/net-service';
import { ErrorService } from 'services/error-service';
import { ValidationController, ValidationRules, Validator, validateTrigger } from 'aurelia-validation';
import { I18N } from 'aurelia-i18n';
import { ToastService } from 'services/toast-service';
import { Router } from 'aurelia-router';

@autoinject
export class SpecialProductCopy {
  private specialProduct: Models.Net;

  formIsValid = false;
  isCopying = false;

  copydata: { NewSpecialProductIdentifier?: string; ExistingSpecialProductId: number };

  constructor(
    private netService: NetService,
    private errorService: ErrorService,
    private i18n: I18N,
    private toastService: ToastService,
    private validationController: ValidationController,
    private validator: Validator,
    private router: Router
  ) {}

  async activate(params: { Id: string | number }) {
    this.validationController.validateTrigger = validateTrigger.changeOrBlur;
    await this.getExistingSpecialProduct(params.Id);
  }

  async getExistingSpecialProduct(specialProductId: number | string) {
    try {
      const specialProduct = await this.netService.get(specialProductId);
      this.specialProduct = specialProduct;
      this.copydata = {
        ExistingSpecialProductId: this.specialProduct.Id,
        NewSpecialProductIdentifier: undefined,
      };

      ValidationRules.ensure('NewSpecialProductIdentifier').required().withMessage(this.i18n.tr('general.requiredField')).on(this.copydata);

      this.validationController.subscribe((event) => {
        if (event.type === 'reset') return;
        this.formIsValid = event.errors.length === 0 && this.copydata.NewSpecialProductIdentifier?.length > 0;
      });
    } catch (error) {
      this.errorService.handleError(error);
    }
  }

  async copySpecialProduct() {
    if (!this.copydata.NewSpecialProductIdentifier) {
      this.toastService.showError('net.copynonewidentifier');
      return;
    }

    this.isCopying = true;

    try {
      const result = await this.netService.copySpecialProduct({
        ExistingSpecialProductId: this.copydata.ExistingSpecialProductId,
        NewSpecialProductIdentifier: this.copydata.NewSpecialProductIdentifier,
      });
      this.isCopying = false;
      this.toastService.showSuccess('net.specialproductcopied');

      this.router.navigateToRoute('special-product-detail', { Id: result.Id });
    } catch (error) {
      this.errorService.handleError(error);
    }
    this.isCopying = false;
  }
}
